import { render, staticRenderFns } from "./fangxun.vue?vue&type=template&id=2eafcc74&scoped=true&"
import script from "./fangxun.vue?vue&type=script&lang=js&"
export * from "./fangxun.vue?vue&type=script&lang=js&"
import style0 from "./fangxun.vue?vue&type=style&index=0&id=2eafcc74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eafcc74",
  null
  
)

export default component.exports